import { toast } from '@raystack/apsara';
import { isEqual } from 'lodash';
import useSWR from 'swr';

import { apiClient } from '@src/clients';

export const useGetSatelliteById = ({ id }: { id: string | null }) => {
  const { data: { data: satelliteData } = {}, isLoading: isSatelliteLoading } =
    useSWR(
      id ? `satellites/${id}` : null,
      () => apiClient.lensApi.getSatellite(id ?? ''),
      {
        onError: error => {
          if (error?.response?.status == 400) {
            console.error(error.response.data);

            toast.error('Something went wrong!', {
              description: error.response.data.detail
            });
          } else if (error?.response?.status == 404) {
            toast.error('Assets not found!', {
              description:
                "This AOI doesn't seem to have any assets. You can still view it without raster visualization!"
            });
          } else {
            toast.error('Oops!', {
              description:
                'Something went wrong while fetching AOI details! Please try again.'
            });
            console.error(error);
          }
        },
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        refreshInterval: 0,
        revalidateOnReconnect: false,
        compare: (a, b) => isEqual(a?.data, b?.data)
      }
    );

  return { satelliteData, isSatelliteLoading };
};
